import apiClient from '@/services/axios';

export async function post(tierLevelId, payload) {
	// Process venue ID similar to membership perks
	if (payload.perkConfig.venueId && !payload.perkConfig.venueId.id) {
		payload.perkConfig.venueId = { id: null };
	}
	
	var payloadFixed = { perkConfig: payload.perkConfig };
	var response = await apiClient.post(`tierlevels/${tierLevelId}/assign-level-reached-perk`, payloadFixed);
	if (response) {
		return response.data;
	}

	throw new Error('Unable to assign level reached perk to existing members.');
} 